import { gsap } from 'gsap/all'

// GnavDrilldownMenu
export default class GnavDrilldownMenu {
  constructor() {
    this.wrapper = document.querySelectorAll('.js-gnav-wrapper')
    this.triggers = Array.from(document.querySelectorAll('.js-gnav-drilldownmenu-trigger'))
    this.backsBtns = Array.from(document.querySelectorAll('.js-gnav-drilldownmenu-back'))
    this.menus = Array.from(document.querySelectorAll('.js-gnav-drilldownmenu-item'))
    this.isOpen = false
    this.isNext = 0
    this.init()
  }

  init() {
    this.bindEvent()
  }

  bindEvent() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', this.clickNext.bind(this))
    })
    this.backsBtns.forEach((btn) => {
      btn.addEventListener('click', this.clickBack.bind(this))
    })
  }

  clickNext(e) {
    const tgt = e.currentTarget
    const menu = tgt.closest('.js-gnav-drilldownmenu-item')
    if (!menu.classList.contains('is-open')) {
      menu.classList.add('is-open')
      const targetBody = menu.querySelector('.js-gnav-drilldownmenu-target')
      this.isNext += 1
      targetBody.scrollTop = 0
      this.nextSegment()
    }
  }

  clickBack(e) {
    const tgt = e.currentTarget
    const menu = tgt.closest('.js-gnav-drilldownmenu-item')
    this.isNext -= 1
    this.nextSegment(() => {
      menu.classList.remove('is-open')
    })
  }

  nextSegment(onComplete = () => {}) {
    gsap.killTweensOf(this.wrapper)
    gsap.to(this.wrapper, {
      duration: 0.5,
      xPercent: -100 * this.isNext,
      ease: 'power3.inOut',
      onComplete: onComplete,
    })
  }

  reset() {
    this.isNext = 0
    this.nextSegment()

    this.menus.forEach((menu) => {
      menu.classList.remove('is-open')
    })
  }
}
